import React from 'react';
import type { LucideIcon } from 'lucide-react';

export interface ChartCategory {
  id: string;
  label: string;
  icon: LucideIcon;
}

interface ChartCategoryFilterProps {
  categories: ChartCategory[];
  selected: string;
  onChange: (id: string) => void;
}

const ChartCategoryFilter: React.FC<ChartCategoryFilterProps> = ({
  categories,
  selected,
  onChange,
}) => {
  return (
    <div className="mb-6">
      <div className="cgm-card rounded-2xl p-2 px-3">
        <div className="flex items-center gap-1.5 overflow-x-auto scrollbar-hide">
          {categories.map((cat) => {
            const isActive = cat.id === selected;
            const Icon = cat.icon;
            return (
              <button
                key={cat.id}
                onClick={() => onChange(cat.id)}
                className={`cgm-tab flex items-center gap-1.5 px-3.5 py-2 rounded-xl transition-all duration-200 whitespace-nowrap text-sm font-medium ${
                  isActive ? 'cgm-tab-active' : ''
                }`}
              >
                <Icon className="w-3.5 h-3.5 flex-shrink-0" />
                <span>{cat.label}</span>
              </button>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default ChartCategoryFilter;
